import { Button } from '@octopus-do/octopus-storybook'
import { Burger as BurgerIcon } from '@octopus-do/octopus-storybook/icons'
import React from 'react'

interface Props {
  active: boolean
  onClick: () => void
}

export const SettingsButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ active, onClick }, ref) => (
    <Button
      ref={ref}
      priority="secondary"
      size="medium"
      left={BurgerIcon}
      aria-label="Settings"
      active={active}
      data-testid="settings"
      onClick={onClick}
    />
  )
)
